// src/State/index.js
import { combineReducers } from 'redux';
import counterReducer from './reducers';
import { watchIncrement } from './sagas';

const rootReducer = combineReducers({
  counter: counterReducer,
});

export { rootReducer, watchIncrement };
